import { useState } from "react";
import "../styles/IndustryServices.css"; // Make sure this CSS file is linked correctly

function IndustryServices() {
  const [hoveredItem, setHoveredItem] = useState(null);

  const descriptions = {
    "Cut To Length": "Used for precise cutting of steel sheets. Ensures accuracy, reduces waste, and improves efficiency in steel manufacturing.",
    "Long Rolling Mills": "Processes steel into long sections for construction and industrial use. Provides durability and high tensile strength.",
    "Processing Line": "Automates steel production for consistent quality. Reduces manual work and increases productivity.",
    "Slitting Line": "Cuts large steel rolls into narrow strips. Used in automotive and construction industries for customized steel sizes.",
    "Automatic Trolly Moving System": "Enhances pharma material handling. Reduces manual effort, speeds up operations, and ensures safety.",
    "OEM Machine": "Custom-built pharmaceutical machines. Optimizes production, maintains hygiene, and complies with regulations.",
    "Material Handling": "Automates pharma supply chains. Improves efficiency, minimizes manual labor, and increases productivity.",
    "Traction Motor Test Bench": "Tests railway traction motors. Ensures optimal performance and long-term reliability.",
    "EP Brake Test Bench": "Tests electronic pneumatic brake systems in trains. Ensures reliable and safe braking.",
    "EP Contactor Test Bench": "Tests electrical contactors in trains. Ensures smooth power distribution and safety.",
    "AWS DMH Transformer Oil Sensor TB": "Checks the quality and safety of transformer oil in railway systems.",
    "AMV-HMV 25kV Pantograph Test Bench": "Tests pantographs for electrical connectivity and performance.",
    "PLV Test, MCB and Other Sensors TB": "Tests various sensors and miniature circuit breakers used in trains.",
    "RDK Test Bench Speedometer TB": "Tests railway speedometers for accurate readings and safety compliance.",
    "Triple Test Bench 80kV Test Bench": "Performs high-voltage testing for railway components.",
    "Different Valve Test Bench": "Tests different types of railway valves for functionality and durability.",
    "DC-DC Converter Test Bench": "Ensures efficiency and reliability of DC-DC converters used in railway systems.",
    "Brake Calibre Test Bench": "Tests brake calipers for wear and performance.",
    "Flasher Unit Test Bench": "Verifies the functionality of railway flasher units.",
    "Dual Pressure Gauge Test Bench": "Tests dual pressure gauges used in railway braking systems.",
    "Master Controller Test Bench": "Tests master controllers in train operation.",
    "Governor Test Bench": "Ensures the performance of railway governors in speed regulation.",
  };

  return (
    <div id="industry-services" className="scrolling-background">
      <div id="industry-services-heading">
        <h2 id="industry-services-title">Our Services</h2>
      </div>
      <div id="industry-services-sections">
        {[
          {
            title: "Steel Industry",
            items: ["Cut To Length", "Long Rolling Mills", "Processing Line", "Slitting Line","Cut To Length", "Long Rolling Mills", "Processing Line", "Slitting Line"],
          },
          {
            title: "Pharma Industry",
            items: ["Automatic Trolly Moving System", "OEM Machine", "Material Handling","Automatic Trolly Moving System", "OEM Machine", "Material Handling"],
          },
          {
            title: "Railway Industry (Electrical)",
            items: [
              "Traction Motor Test Bench",
              "EP Contactor Test Bench",
              "AWS DMH Transformer Oil Sensor TB",
              "AMV-HMV 25kV Pantograph Test Bench",
              "PLV Test, MCB and Other Sensors TB",
              "RDK Test Bench Speedometer TB",
              "Triple Test Bench 80kV Test Bench",
              "DC-DC Converter Test Bench",
              "Flasher Unit Test Bench",
              "Master Controller Test Bench",
              "Governor Test Bench",
            ],
          },
          {
            title: "Railway Industry (Pneumatic)",
            items: [
              "EP Brake Test Bench",
              "Different Valve Test Bench",
              "Brake Calibre Test Bench",
              "Dual Pressure Gauge Test Bench",
              "EP Brake Test Bench",
              "Different Valve Test Bench",
              "Brake Calibre Test Bench",
              "Dual Pressure Gauge Test Bench",
            ],
          },
        ].map((section, index) => (
          <div key={index} className="industry-section">
            <h1>{section.title}</h1>
            <div className="scrolling-container">
              <ul className="industry-list">
                {section.items.map((item, idx) => (
                  <li
                    key={idx}
                    onMouseEnter={() => setHoveredItem(item)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    {item}
                    <div className={`hover-info ${hoveredItem === item ? "show" : ""}`}>
                      {descriptions[item]}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IndustryServices;
